const datePast = (d) => {
  const date = new Date(d);
  const today = Date.now();
  return date < today;
};

export default datePast;
